export function formatTokenCount(n: number): string {
  if (!n) return '0';
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(1)}k`;
  return `${(n / 1_000_000).toFixed(2)}M`;
}

export function formatCurrencyUsd(n: number): string {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// Mirrors the backend's own definition (UsageContext.normalize/2: `spend >= budget`).
// Paired with spend_usd_cycle, not spend_usd_window or spend_usd_lifetime — the
// budget cycle, the report's selected day window, and all-time are three different
// clocks (see usage-api.md caveats). spend_usd_cycle is the one LiteLLM actually
// enforces budget_usd against; spend_usd_lifetime deliberately survives a reset,
// so it no longer reflects current budget standing.
export function isOverBudget(spendUsdCycle: number, budgetUsd: number): boolean {
  return spendUsdCycle >= budgetUsd;
}

// Raw slugs as sent by product services ingesting into observability_events —
// the API returns them as-is, no friendly-label mapping happens server-side.
const SERVICE_LABELS: Record<string, string> = {
  agents: 'Agents',
  playground: 'Migration',
  agentic_platform: 'Agentic Platform',
  'multi-step-agentic': 'Weave / Multi-Agent',
  testing: 'Testing',
  'release-scanner': 'Release Scanner',
};

export function labelForService(service: string): string {
  return SERVICE_LABELS[service] ?? service;
}
